// @ts-nocheck
// import StoreAnchorMenu from "@store/Library/Components/Foundation/StoreAnchorMenu"; // bunzl custom code
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { TextFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// import { siteWidthStyles } from "@toolkit/Themes/common/mixins"; // bunzl custom code
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

// Store Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import StoreAnchorMenu, { StoreAnchorMenuStyles } from "@store/Library/Components/Foundation/StoreAnchorMenu";
import { focusOutlineStyles, siteWidthStyles } from "@toolkit/Themes/common/mixins";

interface RowModel {
    fields: {
        linkTitle: string;
        anchor: string;
        isOpen: boolean;
    };
}

const enum fields {
    rows = "rows",
    isOpenByDefault = "isOpenByDefault",
    hideAnchorMenu = "hideAnchorMenu",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.rows]: RowModel[];
        [fields.isOpenByDefault]: boolean;
        [fields.hideAnchorMenu]: boolean;
    };
}

type Props = OwnProps;

export interface ProductDetailsAccordionStyles {
    anchorMenuWrapper?: InjectableCss;
    accordionWrapper?: InjectableCss;
    accordionSection?: AccordionSectionPresentationProps;
    // Store Custom Code
    anchorMenuStyles?: StoreAnchorMenuStyles;
    openAccordionStyles?: InjectableCss;
    accordionStyles?: InjectableCss;
    sectionWrapper?: InjectableCss;
}

export const productDetailsAccordionStyles: ProductDetailsAccordionStyles = {
    /* bunzl deleted code */
    accordionWrapper: {
        css: css`
            ${siteWidthStyles()}
            /* bunzl custom code start */
            padding: ${pxToRem(24, 64, 48, 64)};
            ${breakpointValues([pxToRem(24, 16, 48, 16), null, null, pxToRem(24, 64, 48, 64)], "padding")}
            background-color: ${getColor("common.shadesLight")};
            /* bunzl custom code end */
        `,
    },
    accordionSection: {
        /* bunzl custom code start */

        panelProps: {
            css: css`
                border: none;
                grid-template-rows: 0fr;
                display: grid;
                opacity: 0;
                transition: grid-template-rows 0.25s ease-in-out;
                > * {
                    overflow: hidden;
                }
            `,
        },
        headerProps: {
            css: css`
                ${breakpointValues([pxToRem(7), null, null, pxToRem(15)], "padding-top")}

                :hover {
                    * {
                        color: ${getColor("primary")};
                    }
                }
                > button {
                    border: none;
                    background-color: ${getColor("common.background")};
                    /* padding-block: ${pxToRem(24)}; */
                    /* margin-block: ${({ theme }) => theme.design.layout.spacing.base}; */
                    :focus-visible {
                        padding: ${pxToRem(9)};
                        padding-left: ${pxToRem(15)};
                        ${focusOutlineStyles()}
                    }
                    :focus {
                        padding: ${pxToRem(9)};
                        padding-left: ${pxToRem(15)};
                    }

                    background-color: ${getColor("common.background")};
                }
            `,
        },
        titleTypographyProps: {
            forwardAs: "h2",
            // Store Custom Code
            css: css`
                margin-bottom: 0;
            `,
        },
    },
    accordionStyles: {
        css: css`
            display: grid;
            gap: ${({ theme }) => theme.design.layout.spacing.smallest};
        `,
    },
    openAccordionStyles: {
        css: css`
            border: none;
            grid-template-rows: 0fr;
            display: grid;
            opacity: 0;
            transition: grid-template-rows 0.25s ease-in-out;
            > * {
                overflow: hidden;
            }
            opacity: 1;
            grid-template-rows: 1fr;
            visibility: visible;
        `,
    },
    anchorMenuStyles: {
        anchorsMenu: {
            css: css`
                background-color: ${getColor("common.shadeLight")};
                justify-content: flex-start;
                ${siteWidthStyles()}
                ${breakpointValues([null, null, null, pxToRem(24, 64, 0, 64)], "padding")}
            `,
        },
        anchorsMenuLink: {
            mergeCss: true,
            css: css`
                padding: 0;
                padding-block: ${pxToRem(7)};
                color: ${getColor("text.main")};
                font-size: ${({ theme }) => theme.design.typography.size.large};
                border-bottom-color: ${getColor("text.main")};
                padding-inline: ${pxToRem(2)};
                text-decoration: none;
                &:hover {
                    text-decoration: none;
                    color: ${getColor("text.main")};
                    border-bottom-color: ${getColor("text.link")};
                }
            `,
        },
    },
    sectionWrapper: {
        css: css`
            border-radius: ${pxToRem(16)};
            gap: ${pxToRem(8)};
            display: flex;
            flex-direction: column;
            background-color: ${getColor("common.background")};
            ${breakpointValues([pxToRem(0, 16, 32, 16), null, null, pxToRem(0, 24, 36, 38)], "padding")}
        `,
    },
    /* bunzl custom code end */
};

const styles = productDetailsAccordionStyles;

export const productDetailsAccordionWrapperId = "productDetailsAccordionWrapperId";

const ProductDetailsAccordion: FC<Props> = ({ id, fields: { rows, isOpenByDefault, hideAnchorMenu } }) => {
    const [accordionRows, setAccordionRows] = useState<RowModel[]>();

    useEffect(() => {
        const newRows: RowModel[] = rows.map(row => ({
            fields: {
                ...row.fields,
                isOpen: isOpenByDefault,
            },
        }));
        setAccordionRows(newRows);
    }, [rows]);

    const onToggleHandler = (expanded: boolean, anchor: string) => {
        /* bunzl custom code code */
        if (accordionRows) {
            const newRows: RowModel[] = accordionRows.map(row => {
                if (row.fields.anchor === anchor) {
                    return {
                        fields: {
                            ...row.fields,
                            isOpen: !expanded,
                        },
                    };
                }

                return row;
            });

            setAccordionRows(newRows);
        }
    };

    if (!accordionRows) {
        return null;
    }

    return (
        <>
            {!hideAnchorMenu && (
                <StyledWrapper {...styles.anchorMenuWrapper}>
                    {/* Store Custom Code */}
                    <StoreAnchorMenu extendedStyles={styles.anchorMenuStyles} links={accordionRows} />
                </StyledWrapper>
            )}
            {/* bunzl custom code start */}
            <StyledWrapper id={productDetailsAccordionWrapperId} {...styles.accordionWrapper}>
                <Accordion {...styles.accordionStyles} headingLevel={2}>
                    {accordionRows?.map(({ fields }, index) => {
                        const rowId = `${fields.anchor}-${index}`;

                        const stylesToUse = fields.isOpen
                            ? styles.openAccordionStyles?.css
                            : styles.accordionSection?.panelProps?.css;
                        const panelProps = {
                            ...styles.accordionSection?.panelProps,
                            css: stylesToUse,
                        };
                        return (
                            <StyledWrapper {...styles.sectionWrapper} key={fields.anchor}>
                                <AccordionSection
                                    title={fields.linkTitle}
                                    headerProps={{
                                        id: fields.anchor,
                                        headingLevel: 2,
                                        ...styles.accordionSection?.headerProps,
                                    }}
                                    uid={fields.anchor}
                                    panelProps={panelProps}
                                    titleTypographyProps={styles.accordionSection?.titleTypographyProps}
                                    onTogglePanel={expanded => onToggleHandler(expanded, fields.anchor)}
                                    expanded={fields.isOpen}
                                >
                                    <Zone contentId={id} zoneName={`Row-${rowId}`} />
                                </AccordionSection>
                            </StyledWrapper>
                        );
                    })}
                </Accordion>
                {/* bunzl custom code end */}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsAccordion,
    definition: {
        group: "Product Details",
        displayName: "Product Accordion",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.rows,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { linkTitle } }) => linkTitle,
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "anchor",
                        displayName: "Element ID",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "linkTitle",
                        displayName: "Row Title",
                        editorTemplate: "TextField",
                        fieldType: "Translatable", // normaly not possible if the type is ChildFieldDefinition instead of FieldDefinition
                        defaultValue: "",
                        isRequired: true,
                    } as TextFieldDefinition,
                ],
            },
            {
                name: fields.isOpenByDefault,
                displayName: "Open all accordions sections by default",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.hideAnchorMenu,
                displayName: "Hide Anchor Menu",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
